// Lightweight EN/FR dictionary for All In One French UI chrome.
// French *learning content* (coach replies, samples, prompts) is NOT translated here.
export const DICT = {
  en: {
    "lang.name": "EN",
    "nav.dashboard": "Dashboard",
    "nav.coaches": "Coaches",
    "nav.tests": "Tests",
    "nav.writingLab": "Writing Lab",
    "nav.speakingLab": "Speaking Lab",
    "nav.samples": "Samples",
    "nav.score": "Score",
    "nav.premium": "Premium",
    "nav.admin": "Admin",
    "nav.logout": "Log out",
    "nav.target": "Target",
    "nav.premiumBadge": "Premium ✦",

    "common.save": "Save",
    "common.back": "Back",
    "common.continue": "Continue",
    "common.tryAgain": "Try again",
    "common.loading": "Loading…",

    "auth.welcomeBackTitle": "Welcome back to your prep.",
    "auth.welcomeBackSub": "Your coaches are ready. Pick up right where you left off.",
    "auth.grindTitle": "You grind late. So do we.",
    "auth.grindSub": "Built for those chasing a life abroad — studying and working like owls, late into the night. All In One French keeps your French moving forward, one focused session at a time.",
    "auth.loginTitle": "Log in",
    "auth.loginSub": "Continue your TCF Canada journey.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.forgot": "Forgot password?",
    "auth.login": "Log in",
    "auth.newHere": "New here?",
    "auth.createAccount": "Create an account",
    "auth.alreadyHave": "Already have an account?",

    "auth.regTitle": "Create your account",
    "auth.regStep1": "Step 1 of 2 — your details.",
    "auth.fullName": "Full name",
    "auth.whatsapp": "WhatsApp number",
    "auth.targetLevel": "Target level",
    "auth.referredBy": "Referred by",
    "auth.optional": "(optional)",
    "auth.verifyTitle": "Verify your email",
    "auth.verifySub": "We sent a 6-digit code to",
    "auth.verifyContinue": "Verify & continue",
    "auth.resend": "Resend code",
    "auth.dreamTitle": "Your Canadian dream starts with French.",
    "auth.dreamSub": "Create your account and get one full day of AI coaching, free.",
    "auth.encrypted": "Your email & data are encrypted.",

    "auth.forgotTitle": "Reset your password",
    "auth.forgotSub": "Enter your email and we'll send a reset code.",
    "auth.sendCode": "Send reset code",
    "auth.resetTitle": "Choose a new password",
    "auth.resetSub": "Enter the code we sent and your new password.",
    "auth.code": "Verification code",
    "auth.newPassword": "New password",
    "auth.resetBtn": "Reset password",
    "auth.backToLogin": "Back to log in",

    "dash.hello": "Bonjour,",
    "dash.premiumActive": "Premium active ✦",
    "dash.trialActive": "Free trial active",
    "dash.trialEnded": "Free trial ended",
    "dash.trialStart": "1 day free trial",
    "dash.premiumDesc": "Unlimited access to all AI coaches.",
    "dash.trialEndedDesc": "Upgrade to keep chatting with your coaches.",
    "dash.trialStartDesc": "Open any coach to start your free day.",
    "dash.seePremium": "See Premium",
    "dash.goPremium": "Go Premium",
    "dash.yourTarget": "Your target level",
    "dash.targetHelp": "Your coaches and scoring adapt to this level.",
    "dash.examDate": "Exam date",
    "dash.examDays": "days",
    "dash.examUntil": "until",
    "dash.examEmpty": "Add your TCF exam date and we'll follow up afterwards to learn which topics you got.",
    "dash.reminders": "Practice reminders",
    "dash.remindersDesc": "A nudge after your exam & daily practice pings.",
    "dash.prepToolkit": "Prep toolkit",
    "dash.yourCoaches": "Your AI coaches",
    "dash.openAll": "Open all",
    "dash.start": "Start",
    "dash.latestTopics": "Latest TCF exam topics",
    "dash.latestTopicsSub": "Fresh topics reported by students & curated by our team.",
    "dash.justGave": "Just gave the exam?",
    "dash.justGaveSub": "Share the writing/speaking topic you received. Write in any language — we'll polish it for everyone.",
    "dash.submitTopic": "Submit topic",

    "toolkit.diagnostic": "Diagnostic",
    "toolkit.diagnosticDesc": "See your CLB now",
    "toolkit.writing": "Writing Lab",
    "toolkit.writingDesc": "Get a real TCF score",
    "toolkit.speaking": "Speaking Lab",
    "toolkit.speakingDesc": "Record & get scored",
    "toolkit.samples": "Sample Answers",
    "toolkit.samplesDesc": "B1 vs B2, explained",
    "toolkit.templates": "Jump Templates",
    "toolkit.templatesDesc": "B1 → B2 frames",
    "toolkit.score": "Score Tracking",
    "toolkit.scoreDesc": "Track your progress",
  },
  fr: {
    "lang.name": "FR",
    "nav.dashboard": "Tableau de bord",
    "nav.coaches": "Coachs",
    "nav.tests": "Tests",
    "nav.writingLab": "Atelier écrit",
    "nav.speakingLab": "Atelier oral",
    "nav.samples": "Exemples",
    "nav.score": "Score",
    "nav.premium": "Premium",
    "nav.admin": "Admin",
    "nav.logout": "Se déconnecter",
    "nav.target": "Objectif",
    "nav.premiumBadge": "Premium ✦",

    "common.save": "Enregistrer",
    "common.back": "Retour",
    "common.continue": "Continuer",
    "common.tryAgain": "Réessayer",
    "common.loading": "Chargement…",

    "auth.welcomeBackTitle": "Ravi de vous revoir.",
    "auth.welcomeBackSub": "Vos coachs sont prêts. Reprenez là où vous vous êtes arrêté.",
    "auth.grindTitle": "Vous travaillez tard. Nous aussi.",
    "auth.grindSub": "Conçu pour ceux qui visent une vie à l'étranger — étudier et travailler comme des hiboux, tard dans la nuit. All In One French fait progresser votre français, une séance à la fois.",
    "auth.loginTitle": "Connexion",
    "auth.loginSub": "Poursuivez votre parcours TCF Canada.",
    "auth.email": "Email",
    "auth.password": "Mot de passe",
    "auth.forgot": "Mot de passe oublié ?",
    "auth.login": "Se connecter",
    "auth.newHere": "Nouveau ici ?",
    "auth.createAccount": "Créer un compte",
    "auth.alreadyHave": "Vous avez déjà un compte ?",

    "auth.regTitle": "Créez votre compte",
    "auth.regStep1": "Étape 1 sur 2 — vos informations.",
    "auth.fullName": "Nom complet",
    "auth.whatsapp": "Numéro WhatsApp",
    "auth.targetLevel": "Niveau cible",
    "auth.referredBy": "Recommandé par",
    "auth.optional": "(facultatif)",
    "auth.verifyTitle": "Vérifiez votre email",
    "auth.verifySub": "Nous avons envoyé un code à 6 chiffres à",
    "auth.verifyContinue": "Vérifier et continuer",
    "auth.resend": "Renvoyer le code",
    "auth.dreamTitle": "Votre rêve canadien commence avec le français.",
    "auth.dreamSub": "Créez votre compte et profitez d'une journée complète de coaching IA, gratuite.",
    "auth.encrypted": "Vos données et votre email sont chiffrés.",

    "auth.forgotTitle": "Réinitialisez votre mot de passe",
    "auth.forgotSub": "Entrez votre email et nous vous enverrons un code.",
    "auth.sendCode": "Envoyer le code",
    "auth.resetTitle": "Choisissez un nouveau mot de passe",
    "auth.resetSub": "Entrez le code reçu et votre nouveau mot de passe.",
    "auth.code": "Code de vérification",
    "auth.newPassword": "Nouveau mot de passe",
    "auth.resetBtn": "Réinitialiser",
    "auth.backToLogin": "Retour à la connexion",

    "dash.hello": "Bonjour,",
    "dash.premiumActive": "Premium actif ✦",
    "dash.trialActive": "Essai gratuit actif",
    "dash.trialEnded": "Essai gratuit terminé",
    "dash.trialStart": "1 jour d'essai gratuit",
    "dash.premiumDesc": "Accès illimité à tous les coachs IA.",
    "dash.trialEndedDesc": "Passez à Premium pour continuer avec vos coachs.",
    "dash.trialStartDesc": "Ouvrez un coach pour commencer votre journée gratuite.",
    "dash.seePremium": "Voir Premium",
    "dash.goPremium": "Passer à Premium",
    "dash.yourTarget": "Votre niveau cible",
    "dash.targetHelp": "Vos coachs et la notation s'adaptent à ce niveau.",
    "dash.examDate": "Date d'examen",
    "dash.examDays": "jours",
    "dash.examUntil": "avant le",
    "dash.examEmpty": "Ajoutez la date de votre examen TCF ; nous vous recontacterons ensuite pour connaître vos sujets.",
    "dash.reminders": "Rappels de pratique",
    "dash.remindersDesc": "Un rappel après votre examen et des pings quotidiens.",
    "dash.prepToolkit": "Boîte à outils",
    "dash.yourCoaches": "Vos coachs IA",
    "dash.openAll": "Tout ouvrir",
    "dash.start": "Commencer",
    "dash.latestTopics": "Derniers sujets d'examen TCF",
    "dash.latestTopicsSub": "Sujets récents signalés par les étudiants et validés par notre équipe.",
    "dash.justGave": "Vous venez de passer l'examen ?",
    "dash.justGaveSub": "Partagez le sujet reçu à l'écrit/oral. Écrivez dans n'importe quelle langue — nous le peaufinerons pour tous.",
    "dash.submitTopic": "Envoyer le sujet",

    "toolkit.diagnostic": "Diagnostic",
    "toolkit.diagnosticDesc": "Votre CLB maintenant",
    "toolkit.writing": "Atelier écrit",
    "toolkit.writingDesc": "Un vrai score TCF",
    "toolkit.speaking": "Atelier oral",
    "toolkit.speakingDesc": "Enregistrez-vous",
    "toolkit.samples": "Exemples de réponses",
    "toolkit.samplesDesc": "B1 vs B2, expliqué",
    "toolkit.templates": "Modèles B1 → B2",
    "toolkit.templatesDesc": "Structures prêtes",
    "toolkit.score": "Suivi du score",
    "toolkit.scoreDesc": "Suivez vos progrès",
  },
};
